import './globalfilter.css';
import React, { useEffect, useMemo, useState } from 'react';
import { Select, SelectOption } from '@cv/eds-react/lib/components/select';
import useCustomerData from '../../Context/CustomerDataContext';
import { Toast, ToastContainer, ToastHeader, ToastBody } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { notification } from '@cv/eds-react/lib/components/notification';
import axios from "../../utils/axios-util";
import { Loading } from '@dsi/react-eds';
import { useSelector, useDispatch } from "react-redux";
import {
  fetchCircleData,
  fetchCityData,
  fetchSiteData
} from './GlobalfiltersData';
import { useGlobalFilterData } from '../../hooks/useGlobalFilterData';

const Globalfilters = (props) => {
  const {
    selectedRegions,
    selectedCircles,
    selectedCities,
    selectedSites,
    selectedRegional,
    selectedTechnology,
    selectedTemporal,
    selectedVendor
  } = props;

  console.log("propsglob", props);
const { dispatch } = useGlobalFilterData();
  const { customer } = useCustomerData();
  const location = useLocation();
 const loading = useSelector((state) => state.regionReducer.loading);
  const [RegionData, setRegionData] = useState([]);
  // const [CircleData, setCircleData] = useState([]);
  // const [CityData, setCityData] = useState([]);
  // const [SiteData, setSiteData] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const CircleData = useSelector(state => state.regionReducer.circleData);
  const CityData = useSelector(state => state.regionReducer.cityData);
  const SiteData = useSelector(state => state.regionReducer.siteData);

//   const masterFilterChange = async (filterType, valuesArray) => {
//   try {
//     const response = await axios.post(`/infra/${customer}/${filterType}api`, valuesArray);
//     if(filterType == "circles"){
//       const data = response.data.map((circleName) => ({
//       name: circleName,
//     }));
//      setCircleData(data);
//   }
//      if(filterType == "citys"){
//       const data1 = response.data.map((cityName) => ({
//       name: cityName,
//     }));
//       setCityData(data1);
//     }
//    if (filterType === "sites") {
//   const allSites = response.data.flatMap(group =>
//     group.sites.map(site => ({
//       nodeId: site.nodeId,
//       name: site.name
//     }))
//   );

//   setSiteData(allSites);
// }
   
//   } catch (error) {
//     console.error(`Fail to fetch ${filterType} API`, error);
//   }
// };

  const handleRegionChange = async (selectedKey, item) => {
    const selectedRegionData = item?.props?.data;
    const regionName = selectedRegionData?.name;
    props.setSelectedRegionData([selectedRegionData]);
    props.setSelectedCircleData([]);
    props.setSelectedCityData([]);
    props.setSelectedSitesData([]);
    //setCircleData([]);
    // setCityData([]);
    // setSiteData([]);
    const request= {
      region: [regionName]
     }
     await dispatch(fetchCircleData(customer, request));
   // masterFilterChange('circles',request)
    // try {
    //   const response = await axios.post(`/infra/${customer}/circlesapi`, {
    //   region: [regionName]
    //  });

    // const circles = response.data.map((name) => ({ name }));
    //  setCircleData(circles);
    // } catch (error) {
    //  console.error("Failed to fetch circles", error);
    //  }
   // filterCircles([selectedRegionData]);
  };

  const handleCircleChange = async (selectedKeys, items) => {
    const selectedCirclesData = items
      ?.map((itm) => itm?.props.data)
      .filter((itm) => itm);
    props.setSelectedCircleData(selectedCirclesData);
    props.setSelectedCityData([]);
    props.setSelectedSitesData([]);
    // setCityData([]);
    // setSiteData([]);
    const request= {
      region: selectedRegions.map((r) => r.name),
      circle: selectedCirclesData.map((c) => c.name)
     }
     await dispatch(fetchCityData(customer, request));
    //masterFilterChange('citys',request)
    //filterCities(selectedCirclesData);
  };

  const handleCityChange = async(selectedKeys, items) => {
    const selectedCitiesData = items
      ?.map((itm) => itm?.props.data)
      .filter((itm) => itm);
    props.setSelectedCityData(selectedCitiesData);
    props.setSelectedSitesData([]);
    //setSiteData([]);
     const request= {
      region: selectedRegions.map((r) => r.name),
      circle: selectedCircles.map((c) => c.name),
      city: selectedCitiesData.map((ci) => ci.name)
     }
     await dispatch(fetchSiteData(customer, request));
   // masterFilterChange('sites',request)
    //filterSites(selectedCitiesData);
  };

  // const handleSiteChange = (selectedKeys, item) => {
  //     const selectedSiteData = item?.props?.data;
  //   const siteName = selectedSiteData?.name;
  //   props.setSelectedSitesData([selectedSiteData]);
  //  //props.selectedSiteData([selectedSiteData])

  // };

  
  const handleSiteChange = (selectedKeys, items) => {
    const selectedItems = Array.isArray(items) ? items : [items];
    const selectedSitesData = selectedItems.map((itm) => itm?.props?.data);
    props.setSelectedSitesData(selectedSitesData);
  };

  const handleVendorChange = (event) => {
    console.log('event.target',event);
    
    props.setSelectedVendorData(event[0]);
  };

  const handleTechnologyChange = (event) => {
    console.log('event.target', event);

    props.setSelectedTechnologyData(event[0]);
  };

  const handleTemporalChange = (event) => {
    console.log('event.target', event);

    props.setSelectedTemporalData(event[0]);
  };

  const handleRegionalChange = (event) => {
    console.log('event.target', props.setSelectedRegionalData);

    props.setSelectedRegionalData(event[0]);
  };

  

  // const filterCircles = (selectedRegions) => {
  //   const result = selectedRegions
  //     ?.filter((region) => region && region.circles)
  //     ?.map((region) => region.circles || [])
  //     .flat();
  //   setCircleData(result || []);
  //   setCityData([]);
  //   setSiteData([]);
  // };

  // const filterCities = (selectedCircles) => {
  //   const allCities = selectedCircles
  //     ?.filter((circle) => circle && circle.cities)
  //     ?.map((circle) =>
  //       circle.cities.map((city) => ({ ...city, circleName: circle.name }))
  //     )
  //     .flat();

  //   const cityNameCount = allCities.reduce((countMap, city) => {
  //     countMap[city.name] = (countMap[city.name] || 0) + 1;
  //     return countMap;
  //   }, {});

  //   const result = allCities.map((city) => {
  //     if (cityNameCount[city.name] > 1) {
  //       return { ...city, name: `${city.name} (${city.circleName})` };
  //     }
  //     return city;
  //   });

  //   setCityData(result || []);
  //   setSiteData([]);
  // };

  // const filterSites = (selectedCities) => {
  //   const result = selectedCities
  //     ?.filter((city) => city && city.sites)
  //     ?.map((city) => city.sites || [])
  //     .flat();
  //   setSiteData(result || []);
  // };

  // Initialize region, circle, city, and site based on detailSite props
//   useEffect(() => {
//   if (
//     selectedRegions?.length === 0 &&
//     selectedCircles?.length === 0 &&
//     selectedCities?.length === 0 &&
//     selectedSites?.length === 0
//   ) {
//    // setCircleData([]);
//     setCityData([]);
//     setSiteData([]);
//   }
// }, [selectedRegions, selectedCircles, selectedCities, selectedSites]);

  // useEffect(() => {
  //   if (props.regionData) {
  //     setRegionData(props.regionData);

  //     // if (selectedRegions?.length > 0) {
  //     //   const circles = selectedRegions.flatMap((region) => region.circles || []);
  //     //   setCircleData(circles);
  //     // }
  //   }
  // }, [props.regionData, selectedRegions]);

  // useEffect(() => {
  //   if (selectedRegions?.length > 0) {
  //     // const circles = selectedRegions.flatMap((region) => region.circles || []);
  //     // setCircleData(circles);

  //     // if (selectedCircles?.length > 0) {
  //     //   const cities = selectedCircles.flatMap((circle) => circle.cities || []);
  //     //   setCityData(cities);
  //     // }
  //   }
  // }, [selectedRegions, selectedCircles]);

  // useEffect(() => {
  //   if (selectedCircles?.length > 0) {
  //     // const cities = selectedCircles.flatMap((circle) => circle.cities || []);
  //     // setCityData(cities);

  //     // if (selectedCities?.length > 0) {
  //     //   const sites = selectedCities.flatMap((city) => city.sites || []);
  //     //   setSiteData(sites);
  //     // }
  //   }
  // }, [selectedCircles, selectedCities]);

  useMemo(() => {
    if (props.regionData) {
      setRegionData(props.regionData);
    }
  }, [props.regionData]);

  useEffect(() => {
    if (customer) {
      const { fetchRegionData } = props;
      fetchRegionData(customer);
    }
  }, [customer]);

  useEffect(() => {
    setShowToast(true);
  }, []);

  const handleRightClick = async (event) => {
    event.preventDefault();
    await navigator.clipboard.writeText(event.target.innerText);
    notification.notice({ title: 'Copied to Clipboard!' });
  }

  let rdData = []
  let slreg=[]
const handleRenChge = () => {

}
  return (
    !location.pathname.startsWith('/performanceManagement') ? <div className="globalfilters">
      {loading && <div className="loader-overlay" style={{color: 'black'}} >
          <Loading size="medium" />
        </div>}
      <Select
        className="single-select"
        dataType="input-single"
        value={selectedRegions?.length ? selectedRegions[0]?.name : ''}
        onChange={handleRegionChange}
        placeholder="Select Region"
      >
        {RegionData.map((region, i) => (
          <SelectOption
            key={`${region?.name || 'region'}-${i}`}
            value={region?.name}
            children={<span title={region?.name}>{region?.name}</span>}
            data={region}
            onContextMenu={(event)=>handleRightClick(event)}
          />
        ))}
      </Select>
      <div>
      {CircleData?.length > 0 && <Select
        className="multi-select"
        dataType="input-multi"
        value={selectedCircles?.map((circle) => circle?.name) || []}
        onChange={handleCircleChange}
        placeholder="Select Circles"
      >
        {CircleData.map((circle, i) => (
          <SelectOption
            key={`${circle?.name || 'circle'}-${i}`}
            value={circle?.name}
            children={<span title={circle?.name}>{circle?.name}</span>}
            data={circle}
            onContextMenu={(event)=>handleRightClick(event)}
          />
        ))}
      </Select>}
     {selectedCircles?.length === 1 && <div className='globalSingleText'>{selectedCircles[0]?.name}</div>}
      </div>
      <div>
      {CityData?.length > 0 && <Select
        className="multi-select"
        dataType="input-multi"
        value={selectedCities?.map((city) => city?.name) || []}
        onChange={handleCityChange}
        placeholder="Select Cities"
      >
        {CityData.map((city, i) => (
          <SelectOption
            key={`${city?.name || 'city'}-${i}`}
            value={city?.name}
            children={<span title={city?.name}>{city?.name}</span>}
            data={city}
            onContextMenu={(event)=>handleRightClick(event)}
          />
        ))}
      </Select>}
     {selectedCities?.length === 1 && <div className='globalSingleText'>{selectedCities[0]?.name}</div>}
      </div>
      <div>
      {SiteData?.length > 0 && <Select
        className="multi-select"
        dataType="input-multi"
        value={selectedSites?.map((site) => site?.name) || []}
        onChange={handleSiteChange}
        placeholder="Select Sites"
        key={`sitedata${SiteData?.length}`}
      >
        {SiteData.map((site, i) => (
          <SelectOption
            key={`${site?.name || 'site'}-${i}`}
            value={site?.name}
            children={<span title={site?.name}>{site?.name}</span>}
            data={site}
            onContextMenu={(event)=>handleRightClick(event)}
          />
        ))}
      </Select>}
      {selectedSites?.length === 1 && <div className='globalSingleText'>{selectedSites[0]?.name}</div>}
      </div>

      {location.pathname.startsWith('/view/infra-topology') && (
        <ToastContainer
          className="p-3 custom-toast-body"
          style={{ zIndex: '400' }}
          position="bottom-end"
        >
          <Toast show={showToast} onClose={() => setShowToast(false)} autohide delay={2000}>
            <ToastHeader closeButton={false}>
              <strong className="me-auto color-blue">Information</strong>
            </ToastHeader>
            <ToastBody>
              Multiple selections are now allowed for circles, cities, and sites.
            </ToastBody>
          </Toast>
        </ToastContainer>
      )}
    </div>:
    <div className="globalfilters">
      <Select
        className="single-select paddingRight5px"
        dataType="input-single"
        value={selectedVendor ? selectedVendor : ''}
        onChange={handleVendorChange}
        placeholder="Vendors"
      >
        {['HUA','ERI'].map((vendors, i) => (
          <SelectOption
            key={`${vendors || 'Vendors'}-${i}`}
            value={vendors}
            children={<span title={vendors}>{vendors}</span>}
            data={vendors}
            onContextMenu={(event) => handleRightClick(event)}
          />
        ))}
      </Select>
      <Select
        className="single-select paddingRight5px"
        dataType="input-single"
        value={selectedTechnology ? selectedTechnology : ''}
        onChange={handleTechnologyChange}
        placeholder="Technology"
      >
        {['GSM','LTE'].map((technology, i) => (
          <SelectOption
            key={`${technology || 'Technology'}-${i}`}
            value={technology}
            children={<span title={technology}>{technology}</span>}
            data={technology}
            onContextMenu={(event) => handleRightClick(event)}
          />
        ))}
      </Select>
      <Select
        className="single-select paddingRight5px"
        dataType="input-single"
        value={selectedTemporal ? selectedTemporal : ''}
        onChange={handleTemporalChange}
        placeholder="Temporal"
      >
          {['15min', 'Hour', 'Day', 'Week', 'Month','cs_bbh'].map((temporal, i) => (
          <SelectOption
            key={`${temporal || 'Temporal'}-${i}`}
            value={temporal}
            children={<span title={temporal}>{temporal}</span>}
            data={temporal}
            onContextMenu={(event) => handleRightClick(event)}
          />
        ))}
      </Select>
      <Select
        className="single-select paddingRight5px"
        dataType="input-single"
        value={selectedRegional ? selectedRegional : ''}
        onChange={handleRegionalChange}
        placeholder="Regional"
      >
          {['cell', 'site', 'node', 'city', 'state', 'region', 'network'].map((regional, i) => (
          <SelectOption
            key={`${regional || 'Regional'}-${i}`}
            value={regional}
            children={<span title={regional}>{regional}</span>}
            data={regional}
            onContextMenu={(event) => handleRightClick(event)}
          />
        ))}
      </Select>

    </div>
  );
};

export default Globalfilters;
